import { HttpClient } from '@angular/common/http';
import { Model } from '@socrates/common';
import { MarshalModelFactory } from '@socrates/common';

export abstract class ISimpleTypeCodeEntitiesRepo<T extends Model> {
	abstract initialized: boolean;
	abstract loadEntities(fullObject?: boolean): Promise<T[]>;
	abstract getEntity(entityId: string): Promise<T>;
	abstract initialize(httpClient: HttpClient, restPath: string, inputType: any, modelFactory: MarshalModelFactory<T>): void;
}
